import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const inputFileInputFn = /* @__PURE__ */ createRecipe('input-file-input', {}, [])

const inputFileInputVariantMap = {}

const inputFileInputVariantKeys = Object.keys(inputFileInputVariantMap)

export const inputFileInput = /* @__PURE__ */ Object.assign(memo(inputFileInputFn.recipeFn), {
  __recipe__: true,
  __name__: 'inputFileInput',
  __getCompoundVariantCss__: inputFileInputFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: inputFileInputVariantKeys,
  variantMap: inputFileInputVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, inputFileInputVariantKeys)
  },
  getVariantProps: inputFileInputFn.getVariantProps,
})